export const NAME = 'publicListing'

export const AMENITY_IN_UNIT_CATEGORIES = ['laundry', 'kitchen', 'heating', 'cooling', 'technology']
export const AMENITY_SHARED_CATEGORIES = ['shared']

export const AMENITY_INCLUDED_WITH_RENT_CATEGORIES = ['utilities']
export const AMENITY_PUBLIC_LISTING_FEATURES = ['design', 'more']
